export default {
  auth: true,
  accreditation: true,
  slug: 'bidding',
}
